export function personScopeUrl(url, mandantId, betriebId) {
  if (!mandantId) throw new Error("Bitte einen Mandanten auswählen.");
  const [path, query = ""] = url.split("?");
  const params = new URLSearchParams(query);
  params.set("mandant_id", mandantId);
  if (betriebId) params.set("betrieb_id", betriebId);
  return `${path}?${params.toString()}`;
}
